export function getGroupName(groupId, groups) {
  return groups?.find((group) => group.id === groupId)?.name;
}
